import createProps from '@kissui/helpers/src/props.helpers'

class YoutubeOverlay extends HTMLElement {
    connectedCallback() {
        const { video_id = '' } = createProps(this.attributes)

        if (video_id) {
            this.render(video_id)
        }
    }

    render(videoId) {
        this.setAttribute('role', 'button')
        this.style.backgroundImage = `url(https://img.youtube.com/vi/${videoId}/sddefault.jpg)`
        this.innerHTML = `
            <div>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="90"
                    height="60"
                    viewBox="0 0 90 60"
                >
                    <rect width="90" height="60" rx="12" fill="#FF0000" />
                    <polygon points="36,15 36,45 60,30" fill="#FFFFFF" />
                </svg>
            </div>
        `
    }
}

customElements.get('nb-youtube-overlay') ||
    customElements.define('nb-youtube-overlay', YoutubeOverlay)

export default YoutubeOverlay
